import React, { Component } from "react";

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import EditorSegments from "./EditorSegments.js";
import Context from "./Context.js";
import Icon from '@material-ui/core/Icon';
import TrendingFlatIcon from '@material-ui/icons/TrendingFlat';
import BlockIcon from '@material-ui/icons/Https';
import Tooltip from '@material-ui/core/Tooltip';
						
class EditorRowInfo extends Component {
	constructor(props) {
		super(props);
		// Estat
		this.state={
			index: this.props.index
		}
		this.pintaIndexSegment = this.pintaIndexSegment.bind(this);
		this.pintaAltTrans = this.pintaAltTrans.bind(this);
		this.handleGotoSegment = this.handleGotoSegment.bind(this);
		this.traspassaSegment = this.traspassaSegment.bind(this);
		this.pintaBlocked = this.pintaBlocked.bind(this);
	}
	componentDidUpdate(){
		if(this.state.index!=this.props.index){
			this.setState({index: this.props.index});
		}
	}
	
	pintaBlocked(){
		if(this.props.segment["trg"]["state"]==="blocked"){
			return <BlockIcon style={{ fontSize: "16px", cursor: "pointer", color: "#880000", marginLeft: "10px" }} onClick={() => this.props.desbloquejaSegment(this.props.index)}/>;
		}else{
			return "";
		}
	}
	
	pintaIndexSegment(){
		var is;
		if(this.props.current){
			is = <Grid item xs={12}><input type="text" size="2" value={this.state.index+1} onChange={this.handleGotoSegment} /> / {this.props.count} {this.pintaBlocked()}</Grid>;
		}else{
			is = <Grid item xs={12}>{this.props.index+1} / {this.props.count} {this.pintaBlocked()}</Grid>;
		}
		return is;
	}
	pintaAltTrans(){
		let lstAltTrans = [];
		for (var key in this.props.segment) {
			//var value = array[key];
			var color="#000";
			var estil;
			switch(key){
				case "ECL TMX":
					if(typeof(this.props.tmxDistance) !== 'undefined'){
						lstAltTrans.push(<span class="ECL TMX" style={{color: color, cursor: "pointer"}}>TM: {this.props.tmxMatch}% [{this.props.tmxDistance.distance}]</span>);
					}else{
						lstAltTrans.push(<span class="ECL TMX" style={{color: color, cursor: "pointer"}}>TM: {this.props.tmxMatch}%</span>);
					}
									break;
				case "ECL TA":
					//color=this.props.segment[key].text==this.props.segment["trg"].text ? "#000":"#d6d6d6";
					if( typeof(this.props.segment["ECL TMX"])==="undefined"){
						//lstAltTrans.push(<span class="ECL TA" style={{color: color, cursor: "pointer"}} onClick={() => this.traspassaSegment(key)}> TA </span>);
						lstAltTrans.push(<span class="ECL TA" style={{color: color, cursor: "pointer"}}> TA </span>);
					}
									break;
			}
		}
		return lstAltTrans;
	}
	handleGotoSegment(e){
		let val = parseInt(e.target.value, 10);
		if(val>0 && val<(this.props.count+1)){
			this.setState({index: val-1});
			this.props.handleGotoSegment(val-1);
		}
	}
	
	traspassaSegment(seg){
		this.props.traspassaSegment(this.state.index, seg);
	}
	
	render() {
		let columnes = [];
		columnes.push(this.pintaIndexSegment());
		columnes = columnes.concat(this.pintaAltTrans());
		columnes.push(<Grid item xs={12}><TrendingFlatIcon style={{ fontSize: "22px", cursor: "pointer" }} onClick={() => this.traspassaSegment("src")}/></Grid>);
		return(<Grid container item direction="column" justify="space-evenly" alignItems="center" xs={12} spacing={1}>{columnes}</Grid>);
	}
}

export default EditorRowInfo;